// extracted by mini-css-extract-plugin
export default {"root":"EditEligibilityGuidelinesDialog_root__rReOw"};